jQuery(document).ready(function () {
  jQuery(".collection-slider").owlCarousel({
    loop: true,
    //margin:10,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 3.6,
      },
      400: {
        items: 4.3,
      },
      600: {
        items: 6,
      },
      768: {
        items: 6.5,
      },
    },
  });

  jQuery(".collection_text").owlCarousel({
    loop: true,
    margin: 10,
    nav: false,
    dots: false,
    responsive: {
      0: {
        items: 2,
        center: true,
      },
      600: {
        items: 3,
        center: true,
      },
      1024: {
        items: 5,
      },
      1600: {
        items: 8,
      },
    },
  });

  var mainHeader = jQuery('.header-sticky-wrapper').outerHeight();
  jQuery('.header-sticky-wrapper').css('height', mainHeader);
  jQuery(window).resize(function() {
    var mainHeader = jQuery('.header-sticky-wrapper').outerHeight();
    jQuery('.header-sticky-wrapper').css('height', mainHeader);
  });
 

  jQuery('.variant-input').click(function(){
    var discount = jQuery(this).attr('data-discount');
    if(discount == undefined || discount == 0){
      jQuery('.product-block--price .product__price.afterchange').removeClass('on-sale');
    }else{
      jQuery('.product-block--price .product__price.afterchange').addClass('on-sale');
    }
  });
  
});

jQuery("body").on("click", "#addToCart", function () {
  var currentVariant = jQuery(this).attr("data-productID");

  let formData = {
    items: [
      {
        id: currentVariant,
        quantity: 1,
      },
    ],
  };
  addItemToCart(formData);
});
async function addItemToCart(formData) {
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await (await fetch("/")).text();
    doc = new DOMParser().parseFromString(data, "text/html");
    cartDrawerContent = doc.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = cartDrawerContent;
    jQuery(".cart-link__bubble").addClass("cart-link__bubble--visible");
    jQuery("#CartDrawer").removeClass("is-empty");
    document.querySelector(".js-drawer-open-cart").click();
  } catch (error) {
    console.error("Error adding item to cart:", error),
      displayCartError(
        "An error occurred while adding the product to the cart."
      );
  }
}
jQuery("body").on("click", ".check-zweite-liebe", function () {
  if (jQuery(this).prop("checked") == true) {
    addNote("Bitte gebrauchten Karton");
  } else {
    addNote("");
  }
});
function addNote(notedata) {
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: {
      note: notedata, // Clear the note by setting it to an empty string
    },
    dataType: "json",
    success: function (cart) {
      console.log("Note updated");
    },
    error: function (xhr, status, error) {
      console.error("Error clearing note: ", error);
      alert("There was an error clearing your note.");
    },
  });
}

jQuery(window).scroll(function () {
  if (jQuery(window).scrollTop() >= 200) {
    jQuery('.top-main-wrapper').addClass('header-sticky');
  }
  else {
    jQuery('.top-main-wrapper').removeClass('header-sticky');
  }
});
